import {useFeaturePermission} from '../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../schema-types/globalTypes';

/**
 * Resolves the correct route paths for the recommendation flow based on whether
 * the user has access to the dentist recommendation builder.
 *
 * - Users with the dentist builder permission are routed to the newer builder
 *   experience (`builder` / `requirements-builder`).
 * - All other users fall back to the BAU recommendation flow
 *   (`recommends-builder` / `requirements`).
 */
export const useRequirementsDentistOrBAU = () => {
  const hasDentistBuilderPerm = useFeaturePermission([
    GlobalPermissionEnum.can_access_dentist_recommendation_builder,
  ]);

  const createRecommendUrl = hasDentistBuilderPerm ? 'builder' : 'recommends-builder';

  const recommendsGridUrl = hasDentistBuilderPerm
    ? 'requirements-builder'
    : 'requirements';

  return {
    createRecommendUrl,
    recommendsGridUrl,
  };
};
